/**
 * 存储服务端接口的权限数据
 */
export default {
  namespaced: true,
  state: {
    urlApis: {},
    regexApis: []
  },
  mutations: {
    initServerApis (state, apiList) {
      console.log('start init server apis data')
      state.urlApis = {}
      state.regexApis = []
      if (apiList) {
        for (let index in apiList) {
          let api = apiList[index]
          if (api.url.indexOf(':') > 0) {
            let apiUrl = api.url.substring(0, api.url.indexOf(':'))
            apiUrl = apiUrl + '[\\w]+'
            let urlPattern = new RegExp(apiUrl)
            api['pattern'] = urlPattern
            state.regexApis.push(api)
          } else {
            state.urlApis[api.url] = api
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/serverApis.js